import * as types from '../constants/actionTypes';
import * as CONSTS from '../constants/constants';
import { NOTIFICATION_COUNT_TYPE } from '../constants/constants';
import * as messageUtils from '../functions/messageUtils';
import { removePrefixAndSuffix } from '../functions/messageUtils';
import * as storageHelper from '../functions/storageHelper';
import WebIM from '../libs/webIM';
import WebIMConfig from '../libs/webIMConfig';
import groupChatService from '../services/groupChatService';
import * as myStore from '../store/myStore';
import { getServerTime } from './commonStateAction';
import { updateStateEventDetail, updateStateGroupChat } from './eventActions';
import * as liveStreamActions from './liveStreamActions';
import * as publicLiveStreamsActions from './publicLiveStreamsActions';
import { TOGGLE_REMINDER_FEATURE_CHAT_ROOM_SUCCESS } from '../constants/actionTypes';
import { SerializedRect } from 'redhotpie-shared-lib/functions/types/popoverTypes';

// Use require for non-TS modules if necessary, or better yet, assume they are handled by build system
const configApp = require('../../app.json');

const isNative = !configApp || !configApp.isWebApp;
let isCall = true;

function getLoginXmppId(): string {
  const login = myStore.getStore().getState().loginReducer;
  if (login && login.userInfo) {
    return login.userInfo.xmppId;
  }
  return '';
}

export function updateSuccess(rooms: any, _authorized: any) {
  return {
    type: types.CHAT_UPDATE_GROUP_SUCCESS,
    rooms,
    authorized: _authorized,
  };
}

export function updateRoomsData(rooms: any) {
  return {
    type: types.CHAT_UPDATE_ROOMS_DATA,
    rooms,
  };
}

export function setIsSortLiveStream(status: boolean) {
  return { type: types.SET_IS_SORT_LIVE_STREAM, data: !!status };
}

export function updateFail() {
  return { type: types.CHAT_UPDATE_GROUP_FAIL };
}

export function updateBannerFreeChatSuccess(data: any) {
  return { type: types.UPDATE_BANNER_FREE_CHAT, data };
}

export function getGroupChatRequest() {
  return { type: types.CHAT_UPDATE_GROUP_REQUEST };
}

export function getRoomMembersDetailRequest(userIds: any[]) {
  return { type: types.GET_ROOM_MEMBERS_DETAIL_REQUEST, userIds };
}

export function getRoomMembersDetailSuccess(members: any[]) {
  return { type: types.GET_ROOM_MEMBERS_DETAIL, members };
}

export function handleUpdateWhisperStatus(messages: any) {
  return { type: types.UPDATE_WHISPER_STATUS_REALTIME, data: messages };
}

export function joinGroupSuccess(room: any) {
  return { type: types.JOIN_CHAT_ROOM_SUCCESS, room };
}

export function quitChatRoomSuccess() {
  return { type: types.QUIT_CHAT_ROOM_SUCCESS };
}

export function bannedSuccess() {
  return { type: types.BANNED_SUCCESS };
}

export function updateAlReadyLogged(data: boolean) {
  return { type: types.UPDATE_AL_READY_LOGGED, data };
}

export function setNextChatRoomSuccess(room: any) {
  return { type: types.SET_NEXT_CHAT_ROOM_SUCCESS, room };
}

export function getRoomDetailSuccess(members: any[]) {
  return { type: types.GET_ROOM_DETAIL_SUCCESS, members };
}
export function userChangeStatusSuccess(data: any) {
  return { type: types.UPDATE_USER_STATUS_SUCCESS, data };
}

export function userUpdateStatusLocalSuccess(data: any) {
  return { type: types.UPDATE_USER_STATUS_LOCAL_SUCCESS, data };
}
export function updateGroupChatMessageStatus(data: any) {
  return { type: types.UPDATE_GROUP_CHAT_MESSAGE_STATUS, data };
}

export function getListUsersStatusSuccess(members: any[], user: any, isLocal: boolean) {
  return {
    type: types.GET_LIST_USERS_STATUS_SUCCESS,
    members,
    data: user,
    isLocal,
  };
}

export function setWaitingProgressSuccess(status: boolean) {
  return {
    type: types.SET_WAITING_PROGRESS_GROUP_CHAT_SUCCESS,
    data: !!status,
  };
}

// export function handleUpdateWhisperStatus(messages) {
//   return dispatch => {
//     dispatch(handleUpdateWhisperStatus(messages));
//   };
// }

export function onJoinGroup(room: any) {
  return (dispatch: any) => {
    groupChatService.postJoinGroupSuccess(room.roomJid).then(() => {
      // Call API update join status in specify room chat
      // GET LIVE STREAM LIST IN ROOM
      if (!WebIMConfig.isDisableLiveStream) {
        const { data, featureRooms } = myStore.getStore().getState().groupChatReducer;
        const roomWillBeSelected = [...data, ...featureRooms].find((r: any) => r.roomJid === room.roomJid);
        if (roomWillBeSelected) {
          dispatch(liveStreamActions.getListLiveStreamsInRoom(roomWillBeSelected.roomId, true));
        }
      }
    });
    dispatch(joinGroupSuccess(room));

    const selectedGroup = myStore.getStore().getState().groupChatReducer.selectedGroup;
    // Only for Desktop
    if (selectedGroup?.roomJid === room.roomJid) {
      // callback destroy livestream
      WebIMConfig.callbackDestroyAllLivestreams?.();
    }
    WebIMConfig.callbackAfterJoinGroup?.();

    dispatch(getServerTime());
  };
}

export function resetClosingTimeGroupChat() {
  return { type: types.RESET_CLOSING_TIME_GROUP_CHAT };
}

export function getGroups(silentMode = false) {
  return (dispatch: any) => {
    !silentMode && dispatch(getGroupChatRequest());
    // dispatch(getChatRoomAuthorized());
    dispatch(resetClosingTimeGroupChat());

    if (silentMode) {
      const rooms = [...myStore.getStore().getState().groupChatReducer.data].map((r: any) => ({
        ...r,
        coverUrl: r.coverUrl,
        liveMembers: r.liveMembers,
        occupants: r.occupants,
        roomDisplayName: r.roomDisplayName,
        roomName: r.roomName,
      }));
      let countQueryRoomInfo = 0;
      rooms.forEach((item: any) => {
        WebIM.conn.queryRoomInfo({
          roomJid: item.roomJid,
          // eslint-disable-next-line consistent-return
          success: (settings: any, members: any, fields: any) => {
            item.occupants = fields.occupants;
            countQueryRoomInfo += 1;
            if (countQueryRoomInfo === rooms.length) {
              dispatch(updateRoomsData(rooms));
              if (!WebIMConfig.isDisableLiveStream) {
                dispatch(liveStreamActions.getListLiveStreams());
              }
            }
          },
          // eslint-disable-next-line consistent-return
          error: (e: any) => {
            countQueryRoomInfo += 1;
            if (countQueryRoomInfo === rooms.length) {
              dispatch(updateRoomsData(rooms));
              // /GET LIVE STREAM LIST
              if (!WebIMConfig.isDisableLiveStream) {
                dispatch(liveStreamActions.getListLiveStreams());
              }
            }
            dispatch(updateFail());
            console.log('error:', e);
          },
        });
      });
      return '';
    }
    // eslint-disable-next-line consistent-return
    return Promise.all([
      groupChatService.getGroupsChat(),
      groupChatService.getChatRoomAuthorized(),
      groupChatService.getFreeHoursChatRoom(),
    ]).then(([res, res1, res2]) => {
      if (res1 && res1.success) {
        dispatch(updateChatRoomAuthorizedSuccess({ ...res.data }));
      }
      if (res.success && res2.success) {
        const rooms = res.data;
        const featureRooms = res2.data?.featureRooms;

        dispatch(updateBannerFreeChatSuccess(res2.data));

        let countQueryRoomInfo = 0;
        if (rooms.length === 0) {
          dispatch(updateSuccess(rooms, {}));
          return res;
        }
        dispatch(updateSuccess(rooms, res1 && res1.success ? res1.data : {}));
        let isLoadedRoomInfo = false;

        const intervalCheckOpenWebSocket = setInterval(() => {
          if (WebIM.conn.isOpened()) {
            // Clear interval
            clearInterval(intervalCheckOpenWebSocket);
            // query room information

            dispatch(getFeatureRoomsOccupants(featureRooms || []));

            rooms.forEach((item: any) => {
              WebIM.conn.queryRoomInfo({
                ...item,
                // eslint-disable-next-line consistent-return
                success: (settings: any, members: any, fields: any) => {
                  isLoadedRoomInfo = true;
                  item.occupants = fields.occupants;
                  countQueryRoomInfo += 1;

                  if (countQueryRoomInfo === rooms.length) {
                    if (res1 && res1.success) {
                      dispatch(
                        updateSuccess(rooms, {
                          ...res1.data,
                        })
                      );
                    }
                    //                    dispatch(updateSuccess(rooms, { CanAccessChat: true, Reason: 'Authorized', IsModerator: true }));
                    // /GET LIVE STREAM LIST
                    if (!WebIMConfig.isDisableLiveStream) {
                      dispatch(liveStreamActions.getListLiveStreams());
                    }
                    return res;
                  }
                },
                // eslint-disable-next-line consistent-return
                error: (e: any) => {
                  isLoadedRoomInfo = true;
                  countQueryRoomInfo += 1;
                  if (countQueryRoomInfo === rooms.length) {
                    dispatch(updateSuccess(rooms, {}));
                    // /GET LIVE STREAM LIST
                    if (!WebIMConfig.isDisableLiveStream) {
                      dispatch(liveStreamActions.getListLiveStreams());
                    }
                    return res;
                  }
                  dispatch(updateFail());
                  console.log('error:', e);
                },
              });
            });
          }
        }, 200);

        /**
         * if overtime (10 seconds), dispatch array empty
         */
        // eslint-disable-next-line consistent-return
        setTimeout(() => {
          clearInterval(intervalCheckOpenWebSocket);
          if (!isLoadedRoomInfo) {
            dispatch(updateFail());
            return res;
          }
        }, 30000);
      } else {
        dispatch(updateFail());
        return res;
      }
    });
  };
}

export function updateChatRoomAuthorizedSuccess(_chatRoomAuthorized: any) {
  return {
    type: types.UPDATE_CHAT_ROOM_AUTHORIZED_SUCCESS,
    data: _chatRoomAuthorized,
  };
}

export function checkChatRoomAuthorized() {
  return (dispatch: any) => {
    return groupChatService.getChatRoomAuthorized().then((res: any) => {
      if (res.success) {
        dispatch(updateChatRoomAuthorizedSuccess({ ...res.data }));
      }
      return res;
    });
  };
}

export function getRoomMembersDetail(members: any[]) {
  return (dispatch: any) => {
    const dataUser = myStore.getStore().getState().usersReducer.users;
    const { userIdsCalledAPI } = myStore.getStore().getState().usersReducer;
    const params: any[] = [];
    if (dataUser && dataUser.length > 0 && members && members.length > 0) {
      const memberGetSummaries: any[] = [];
      const lengthMember = members.length;
      for (let i = 0; i < lengthMember; i++) {
        // eslint-disable-next-line eqeqeq
        const member = dataUser.find((e: any) => e.userId == members[i].name);
        if (!member) {
          memberGetSummaries.push(members[i]);
        }
      }
      if (memberGetSummaries && memberGetSummaries.length > 0) {
        memberGetSummaries.forEach((member: any) => {
          if (!userIdsCalledAPI.includes(member.name)) {
            params.push(member.name);
          }
        });
        if (params.length > 0) {
          dispatch(getRoomMembersDetailRequest(params));
          groupChatService.getGroupChatMembers(params).then((res: any) => {
            dispatch(getRoomMembersDetailSuccess(res));
          });
        }
      }
    } else {
      members.forEach((member: any) => {
        if (!userIdsCalledAPI.includes(member.name)) {
          params.push(member.name);
        }
      });
      if (params.length > 0) {
        dispatch(getRoomMembersDetailRequest(params));
        groupChatService.getGroupChatMembers(params).then((res: any) => {
          dispatch(getRoomMembersDetailSuccess(res));
        });
      }
    }
  };
}

export function joinGroup(room: any, userId: any) {
  return (dispatch: any) => {
    WebIM.conn.joinChatRoom({
      roomJid: room.roomJid,
      historyChat: true,
    });

    if (userId) {
      dispatch(requireLeaveRooms(userId)); // send user in other device signal leave room
    }
  };
}

export function quitChatRoom(room: any) {
  return (dispatch: any) => {
    if (room && room.roomJid) {
      dispatch(postLeaveGroupSuccess(room)); // hop vv fixed
      WebIM.conn.quitChatRoom({
        roomJid: room.roomJid,
      });
      dispatch(liveStreamActions.setListCurrentLiveStreamInRoomSuccess([]));
      dispatch({ type: types.CLEAR_JOINING_MEMBER_PUBLIC_GROUP_CHAT });
    }
  };
}

export function postLeaveGroupSuccess(room: any) {
  return (dispatch: any) => {
    return groupChatService.postLeaveGroupSuccess(room.roomJid);
  };
}

export function getRoomMembers({ roomJid }: { roomJid: string }) {
  return (dispatch: any, getState: any) => {
    const { selectedGroup } = myStore.getStore().getState().groupChatReducer;
    if (roomJid && selectedGroup?.roomJid === roomJid) {
      dispatch({ type: types.LOADING_PUBLIC_GROUP_CHAT_MEMBER, data: true });
      WebIM.conn.queryRoomOccupants({
        roomJid,
        success(members: any[]) {
          // Check condition again to avoid async issue
          if (selectedGroup?.roomJid === roomJid) {
            const memberJids = members.map(m => m.jid);
            // set time out call api because message "memberJoinPublicGroupSuccess" (line 118) response 2
            const membersJoiningCache = getState().groupChatReducer.membersJoining[roomJid] || [];
            const listMembers = [...members];
            for (let i = 0; i < membersJoiningCache.length; i++) {
              if (!memberJids.includes(membersJoiningCache[i].jid)) {
                listMembers.push(membersJoiningCache[i]);
              }
            }
            dispatch({ type: types.CLEAR_JOINING_MEMBER_PUBLIC_GROUP_CHAT });
            dispatch(getRoomMembersDetail(listMembers));
            dispatch(getListUsersStatus(listMembers, roomJid));
          }
        },
      });
    }
  };
}

export function changeStatus({ roomJid, userId, status }: { roomJid: string; userId: number; status: any }) {
  groupChatService
    .updateUserStatus(messageUtils.addPrefixAndSuffix(userId), {
      status,
    })
    .then((res: any) => {
      // console.log("co qua",res,messageUtils.addPrefixAndSuffix(userId),userId);
    });
  return (dispatch: any) => {
    WebIM.conn.changeUserStatus({
      roomJid,
      status,
      type: 'Available',
      success() {},
      error() {
        // console.log('--changestatus--error--');
      },
    });
  };
}
export function updateUserStatus(data: any) {
  return (dispatch: any) => {
    // groupChatService.updateUserStatus(messageUtils.addPrefixAndSuffix(userId), { status: status }).then(res => {
    //   if (res) {
    //     let roomJid = myStore.getStore().getState().groupChatReducer.selectedGroup.roomJid;
    //     if (roomJid !== null) {
    //       dispatch(userChangeStatusSuccess(res));
    //     } else {
    //       console.log("co qua",res);
    //       dispatch(publicLiveStreamsActions.userChangeStatusSuccess(res));
    //     }
    //   }
    // });
    const { roomJid } = myStore.getStore().getState().groupChatReducer.selectedGroup;
    if (roomJid !== null) {
      dispatch(userChangeStatusSuccess(data));
    } else {
      dispatch(publicLiveStreamsActions.userChangeStatusSuccess(data));
    }
  };
}
export function createGroupChat({ roomJid }: { roomJid: string }) {
  return (dispatch: any) => {
    WebIM.conn.createGroup({
      roomJid,
      success() {
        // console.log("create room success");
      },
    });
  };
}

export function destroyChatRoom({ roomJid }: { roomJid: string }) {
  return () => {
    WebIM.conn.destroyGroup({
      roomJid,
      success() {
        // console.log("success");
      },
    });
  };
}

export function getListUsersStatus(members: any[], roomJid: string) {
  return (dispatch: any) => {
    const memberStatus = myStore.getStore().getState().groupChatReducer.selectedGroup.members;
    const params: string[] = [];
    if (memberStatus && memberStatus.length > 0 && members && members.length > 0) {
      dispatch(getListUsersStatusSuccess(members, memberStatus, true));
    } else {
      members.forEach((member: any) => {
        params.push(messageUtils.addPrefixAndSuffix(member.name));
      });
      if (params && params.length > 0) {
        groupChatService.getListUsersStatus({ userXmppIds: params.toString() }, roomJid).then((res: any) => {
          if (res && res.items) {
            dispatch(getListUsersStatusSuccess(members, res.items, false));
          }
        });
      } else {
        dispatch({ type: types.LOADING_PUBLIC_GROUP_CHAT_MEMBER, data: false });
      }
    }
  };
}

export function updateLiveMember(data: any) {
  return { type: types.UPDATE_LIVE_MEMBER, data };
}

export function toggleToCloseLiveStream(data: boolean) {
  return { type: types.TOGGLE_CLOSE_LIVE_STREAM, data };
}

export function loadingGroupChatCanBeInvite(loading: boolean) {
  return { type: types.LOADING_GROUP_CHAT_CAN_BE_INVITE, loading };
}

export function getGroupChatCanBeInviteSuccess(data: any[]) {
  return { type: types.GET_GROUP_CHAT_CAN_BE_INVITE_SUCCESS, data };
}

export function addGroupShouldSendJoinMessage(data: any) {
  return { type: types.ADD_GROUP_SHOULD_SEND_JOIN_MESSAGE, data };
}

export function removeGroupShouldSendJoinMessage(data: any) {
  return { type: types.REMOVE_GROUP_SHOULD_SEND_JOIN_MESSAGE, data };
}

export function addRoomJidShouldSendJoinMessage(data: any) {
  return { type: types.ADD_ROOMJID_SHOULD_SEND_JOIN_MESSAGE, data };
}

export function addRoomJidSendingJoinMessage(data: any) {
  return { type: types.ADD_ROOMJID_SENDING_JOIN_MESSAGE, data };
}

export function removeRoomJidShouldSendJoinMessage(data: any) {
  return { type: types.REMOVE_ROOMJID_SHOULD_SEND_JOIN_MESSAGE, data };
}

export function toggleReminderFeatureChatRoomSuccess(data: any) {
  return { type: types.TOGGLE_REMINDER_FEATURE_CHAT_ROOM_SUCCESS, data };
}

// export function getChatRoomAuthorized() {
//   return dispatch => {
//     return groupChatService.getChatRoomAuthorized().then(res => {
//       console.log('action',res)
//       return res
//     });
//   };
// }

export function createUserChatroomBan(params: any, userBanedId: any) {
  return (dispatch: any) => {
    return groupChatService.createUserChatroomBan(params, userBanedId).then((res: any) => {
      // console.log('action',res)
      return res;
    });
  };
}

export function setProfileNoteMemberSuccess(data: any, _userBanedId: any) {
  return {
    type: types.SET_PROFILE_NOTE_MEMBER_SUCCESS,
    data,
    userBanedId: _userBanedId,
  };
}

export function getNoteBanChatroom(params: any, userBanedId: any) {
  return (dispatch: any) => {
    return groupChatService.getNoteBanChatroom(params, userBanedId).then((res: any) => {
      // console.log('setProfileNoteMemberSuccess',res, params, userBanedId)
      if (res.success && res.data) {
        dispatch(setProfileNoteMemberSuccess(res.data.items, userBanedId));
      }
      return res;
    });
  };
}

export function postNoteBanChatroom(params: any, userBanedId: any) {
  return (dispatch: any) => {
    return groupChatService.postNoteBanChatroom(params, userBanedId).then((res: any) => {
      // console.log('action',res, params, userBanedId)
      return res;
    });
  };
}

export function sendBannedUser(roomJid: string, toUserBanedId: any) {
  return (dispatch: any) => {
    const msgId = WebIM.conn.getUniqueId();
    const msg = new WebIM.message('banned', msgId);
    msg.set({
      to: roomJid,
      data: toUserBanedId,
    });
    WebIM.conn.send(msg.body);
  };
}

export function sendBlockedUser(roomJid: string, toUserBlockedId: any) {
  return (dispatch: any) => {
    const msgId = WebIM.conn.getUniqueId();
    // eslint-disable-next-line new-cap
    const msg = new WebIM.message('blocked', msgId);
    msg.set({
      to: roomJid,
      data: toUserBlockedId,
    });
    WebIM.conn.send(msg.body);
  };
}

export function sendWhisperStatus(roomJid: string, isWhisper: boolean) {
  return (dispatch: any) => {
    const msgId = WebIM.conn.getUniqueId();
    const msg = new WebIM.message('whisper', msgId);
    msg.set({
      to: roomJid,
      data: isWhisper,
    });
    WebIM.conn.send(msg.body);
  };
}

export function updateFeatureRoomsData(featureRooms: any) {
  return { type: types.UPDATE_FEATURE_ROOMS_DATA, data: featureRooms };
}

export function updateFeatureRoomData(room: any) {
  return { type: types.UPDATE_FEATURE_ROOM_DATA, room };
}

export function updateSelectedGroupData(data: any) {
  return { type: types.UPDATE_SELECTED_GROUP_DATA, data: data || {} };
}

export function getFeatureRoomsOccupants(featureRooms: any[]) {
  return (dispatch: any, getState: any) => {
    if (featureRooms && featureRooms.length > 0) {
      let countQueryRoomInfo = 0;
      const { userId } = getState().loginReducer.userInfo;
      featureRooms.forEach(item => {
        WebIM.conn.queryRoomInfo({
          roomJid: item.roomJid,
          // eslint-disable-next-line consistent-return
          success: (settings: any, members: any, fields: any) => {
            item.occupants = Number(fields.occupants);
            item.ownerXmppId = fields.roomowners;
            item.ownerUserId = Number(removePrefixAndSuffix(fields.roomowners));
            item.isOwner = userId === item.ownerUserId;
            countQueryRoomInfo += 1;
            if (countQueryRoomInfo === featureRooms.length) {
              dispatch(updateFeatureRoomsData(featureRooms));
              if (!WebIMConfig.isDisableLiveStream) {
                dispatch(liveStreamActions.getListLiveStreams());
              }
            }
          },
          // eslint-disable-next-line consistent-return
          error: (e: any) => {
            countQueryRoomInfo += 1;
            if (countQueryRoomInfo === featureRooms.length) {
              dispatch(updateFeatureRoomsData(featureRooms));
              // /GET LIVE STREAM LIST
              if (!WebIMConfig.isDisableLiveStream) {
                dispatch(liveStreamActions.getListLiveStreams());
              }
            }
            dispatch(updateFail());
            console.log('error:', e);
          },
        });
      });
    } else {
      dispatch(updateFeatureRoomsData(featureRooms));
    }
  };
}

export function getFreeHoursChatRoom() {
  return (dispatch: any) => {
    dispatch(resetClosingTimeGroupChat());
    return groupChatService.getFreeHoursChatRoom().then((res: any) => {
      // Update banner to reducer
      dispatch(updateBannerFreeChatSuccess(res.data));
      return res;
    });
  };
}

// To use this function User must be set admin role on server
export function kickUserFromGroupChat(roomJid: string, listUserKicked: any) {
  return (dispatch: any) => {
    WebIM.conn.leaveGroup({
      roomJid,
      list: listUserKicked,
      success() {
        console.log('kickUserFromGroupChat room success');
      },
      error() {
        console.log('--kickUserFromGroupChat--error--');
      },
    });
  };
}

// TODO: Start Action handle one user with multi device
export function checkUserInRooms(userId: any) {
  let fromUserJid = storageHelper.getKey(CONSTS.SESSIONS.JID_RESOURCE);
  if (isNative) {
    fromUserJid = getStore().getState().loginReducer.jIdResource;
  }

  const params = {
    fromUserId: `${userId}`,
    toUserId: `${userId}`,
    fromUserJid: `${fromUserJid}`,
    action: {
      name: CONSTS.ACTION_NAME_SIGNAL_CHATROOM.CHECK_STATUS,
    },
    type: NOTIFICATION_COUNT_TYPE.DO_ACTION,
  };
  // console.log("send check status", params);
  return (dispatch: any) => {
    return groupChatService.checkUserInRooms(params).then((res: any) => {
      return res;
    });
  };
}

function getStore() {
  return myStore.getStore();
}

export function relyCheckStatusUserInRooms(dataMessage: any, userId: any) {
  // auto
  // eslint-disable-next-line consistent-return
  return (dispatch: any) => {
    let fromUserJid = storageHelper.getKey(CONSTS.SESSIONS.JID_RESOURCE);
    if (isNative) {
      fromUserJid = getStore().getState().loginReducer.jIdResource;
    }

    const { roomJid } = getStore().getState().groupChatReducer.selectedGroup;
    if (`${dataMessage.fromUserJid}` !== `${fromUserJid}` && roomJid) {
      const params = {
        fromUserId: userId.toString(),
        toUserId: userId.toString(),
        fromUserJid: dataMessage.fromUserJid,
        action: {
          name: CONSTS.ACTION_NAME_SIGNAL_CHATROOM.RELY_STATUS, // checkStatus, relyStatus, leaveRoom
        },
        data: {
          status: {
            roomJid,
            jid: '',
          },
        },
        type: NOTIFICATION_COUNT_TYPE.DO_ACTION,
      };
      // console.log("send reply in room", params);
      return groupChatService.checkUserInRooms(params).then((res: any) => {
        return res;
      });
    }
    dispatch(updateAlReadyLogged(false));
  };
}

export function handleReceiveRelyStatus(dataMessage: any) {
  // auto
  return (dispatch: any) => {
    let fromUserJid = storageHelper.getKey(CONSTS.SESSIONS.JID_RESOURCE);
    if (isNative) {
      fromUserJid = getStore().getState().loginReducer.jIdResource;
    }
    if (dataMessage.fromUserJid === fromUserJid) {
      dispatch(updateAlReadyLogged(true));
    }
  };
}

export function requireLeaveRooms(userId: any) {
  // let fromUserJid = storageHelper.getKey(CONSTS.SESSIONS.JID_RESOURCE);
  let { fromUserJid } = getStore().getState().loginReducer.userInfo;
  if (isNative) {
    fromUserJid = getStore().getState().loginReducer.jIdResource;
  }

  const params = {
    fromUserId: userId.toString(),
    toUserId: userId.toString(),
    fromUserJid: fromUserJid.toString(),
    action: {
      name: CONSTS.ACTION_NAME_SIGNAL_CHATROOM.LEAVE_ROOM,
    },
    type: NOTIFICATION_COUNT_TYPE.DO_ACTION,
  };
  // console.log("send param require leave", params);
  return (dispatch: any) => {
    return groupChatService.checkUserInRooms(params).then((res: any) => {
      return res;
    });
  };
}

export function handleReceiveLeaveRoom(dataMessage: any) {
  // auto
  let { fromUserJid } = getStore().getState().loginReducer.userInfo;
  if (isNative) {
    fromUserJid = getStore().getState().loginReducer.jIdResource;
  }
  const { roomJid } = getStore().getState().groupChatReducer.selectedGroup;
  // console.log("dataMessage.fromUserJid", dataMessage.fromUserJid)
  // console.log("fromUserJid", fromUserJid);
  // console.log("roomJid", roomJid);
  if (`${dataMessage.fromUserJid}` !== `${fromUserJid}` && roomJid && WebIMConfig.getOutChatRoom) {
    WebIMConfig.getOutChatRoom();
  }
}

export function removeRoom(roomJid: string) {
  return { type: types.REMOVE_PUBLIC_GROUP_CHAT, roomJid };
}

export function addMemberJoiningGroup(memberData: any, roomJid: string) {
  return { type: types.ADD_JOINING_MEMBER_PUBLIC_GROUP_CHAT, memberData, roomJid };
}

// function for set/delete reminder
export function setChatRoomReminder(roomId: any) {
  return (dispatch: any) => {
    return groupChatService.setChatRoomReminder(roomId).then((res: any) => {
      if (res.success) {
        dispatch(toggleReminderFeatureChatRoomSuccess(roomId));
      }
      return res;
    });
  };
}

export function deleteChatRoomReminder(roomId: any) {
  return (dispatch: any) => {
    return groupChatService.deleteChatRoomReminder(roomId).then((res: any) => {
      if (res.success) {
        dispatch(toggleReminderFeatureChatRoomSuccess(roomId));
      }
      return res;
    });
  };
}

export function getGroupsCanBeInvited(userId: any) {
  return (dispatch: any) => {
    dispatch(loadingGroupChatCanBeInvite(true));
    return groupChatService.getGroupsCanBeInvited(userId).then((res: any) => {
      if (res.success) {
        dispatch(getGroupChatCanBeInviteSuccess(res.data));
      }
      dispatch(loadingGroupChatCanBeInvite(false));
      return res;
    });
  };
}

export function getGroupChatMessageStatus() {
  return (dispatch: any) => {
    return groupChatService.getGroupChatMessageStatus().then((res: any) => {
      if (res.success) {
        dispatch(updateGroupChatMessageStatus(res.data));
      }
      return res;
    });
  };
}

export function sendGroupsChatInvite(roomJid: string, userId: any) {
  return (dispatch: any) => {
    return groupChatService.sendGroupsChatInvite(roomJid, userId).then((res: any) => {
      return res;
    });
  };
}

export function getGroupChatMember(roomJid: string, userId: any) {
  return (dispatch: any) => {
    return groupChatService.getGroupChatMember(roomJid, userId).then((res: any) => {
      return res;
    });
  };
}

export function getCurrentGroupChatMemberStatus(roomJid: string) {
  return (dispatch: any) => {
    return groupChatService.getCurrentGroupChatMemberStatus(roomJid).then((res: any) => {
      return res;
    });
  };
}

export function revokeGroupToken(roomJid: string) {
  return (dispatch: any) => {
    return groupChatService.revokeGroupToken(roomJid).then((res: any) => {
      return res;
    });
  };
}

export function getGroupChatDetail(roomJid: string) {
  return (dispatch: any) => {
    return groupChatService.getGroupChatDetail(roomJid).then((res: any) => {
      return res;
    });
  };
}
export function removeMemberJoiningGroup(memberData: any, roomJid: string) {
  return { type: types.REMOVE_JOINING_MEMBER_PUBLIC_GROUP_CHAT, memberData, roomJid };
}

const serializeDOMRect = (rect: DOMRect): SerializedRect | null => {
  if (!rect) return null;

  return {
    x: rect.x,
    y: rect.y,
    width: rect.width,
    height: rect.height,
    top: rect.top,
    right: rect.right,
    bottom: rect.bottom,
    left: rect.left,
  };
};

export function updateOptionProfileSummary(data: any) {
  return {
    type: types.UPDATE_OPTIONS_PROFILE_SUMMARY_SUCCESS,
    data: data
      ? {
          ...data,
          domReact: serializeDOMRect(data.domReact),
        }
      : null,
  };
}

export function updateReminderFeatureRoomItem(roomId: any) {
  return { type: types.TOGGLE_REMINDER_FEATURE_CHAT_ROOM_SUCCESS, data: roomId };
}
